import styled from 'styled-components'

export const CommonBlogPostBodyUi = styled.div`
  position: relative;
  width: 100%;
`
